import AboutSlider from './slider'

export default AboutSlider